export function isExpectedEventCommentActivityProbeFailure(error) {
  const code = String(error?.code || '').trim().toLowerCase();
  return code === 'permission-denied'
    || code === 'firestore/permission-denied'
    || code === 'functions/permission-denied'
    || code === 'internal'
    || code === 'functions/internal'
    || code === 'deadline-exceeded'
    || code === 'functions/deadline-exceeded';
}
